
export const theme_default = {
    global: {
        colors: {
            brand: '#4682B4',
            ttok: '#00873D',
            ttoklight: '#A9F78D',
            ttpartial: '#FDFB98',
            ttdown: '#B4130B',
            ttdownlight: '#F51A0F',
            ttwarning: '#C0C011',
            ttcompany: '#FF8800',
            tthelp: "#0197F6"
        },
        font: {
            family: "'Metrophobic', sans-serif",
            size: '14px',
            height: '20px',
        },
        input: {
            border: {
                radius: "2px"
            }
        },
        box: {
            padding: "2px"
        }
    },
}


export const theme_dark = {
    global: {
        colors: {
            brand: '#23395d',
            ttok: '#00873D',
            ttoklight: '#30BC4A',
            ttpartial: '#FDFB98',
            ttdown: '#B4130B',
            ttdownlight: '#CD3021',
            ttwarning: '#C0C011',
            ttcompany: '#FF8800',
            "light-1": "#F2F2F2",
            "light-2": "#EDEDED",
            "light-3": "#DADADA",
            "light-6": "#CCCCCC",
            "dark-2" : "#555555",
            "dark-3" : "#333333",
            "dark-4" : "black",
            tthelp: "#0197F6"
        },
        layer: {
            "background": "#111111",
            "overlay": {
                "background": "rgba(48,48,48,0.5)"
            }
        },
        font: {
            family: "'Metrophobic', sans-serif",
            size: '14px',
            height: '20px',
        },
        input: {
            border: {
                radius: "2px"
            }
        },
        box: {
            padding: "2px"
        },
        "drop": {
            "background": "#333333"
        },
    },
}

export const theme_darker = {
    global: {
        colors: {
            brand: '#21262d',
            ttok: '#196c2e',
            ttoklight: '#30BC4A',
            ttpartial: '#f8e3a1',
            ttdown: '#da3633',
            ttdownlight: '#CD3021',
            ttwarning: '#C0C011',
            ttcompany: '#f0883e',
            "light-1": "#f0f6fc",
            "light-2": "#c9d1d9",
            "light-3": "#b1bac4",
            "light-6": "#6e7681",
            "dark-2" : "#21262d",
            "dark-3" : "#0d1117",
            "dark-4" : "#010409",
            tthelp: "#0197F6"
        },
        layer: {
            "background": "#111111",
            "overlay": {
                "background": "rgba(48,48,48,0.5)"
            }
        },
        font: {
            family: "'Metrophobic', sans-serif",
            size: '14px',
            height: '20px',
        },
        input: {
            border: {
                radius: "2px"
            }
        },
        box: {
            padding: "2px"
        },
        "drop": {
            "background": "#333333"
        },
    },
}

export const ThemeOptions = ['Default', 'Dark', 'Darker']

export const ChosenTheme = () => {
    if (localStorage.getItem("theme") && localStorage.getItem("theme") === 'Dark') {
        return theme_dark
    } else if (localStorage.getItem("theme") && localStorage.getItem("theme") === 'Darker') {
        return theme_darker
    }
    return theme_default
}

export const JsonInvert = () => {
    if (localStorage.getItem("theme") && localStorage.getItem("theme") === 'Default') {
        return true
    }
    return false
}
export default ChosenTheme